/**
 * This file is auto-generated. Any modifications will be
 * overwritten by the generate-icon npm script.
 */
import React from 'react';
import { SvgHifiIcon } from "../shared/SvgHifiIcon";
var CloudUploadHifiIcon = function CloudUploadHifiIcon(props) {
  return /*#__PURE__*/React.createElement(SvgHifiIcon, props, /*#__PURE__*/React.createElement("path", {
    d: "M38 38H29V36H38C41.32 36 44 33.32 44 30C44 26.68 41.32 24 38 24H35V23C35 16.92 30.08 12 24 12C18.96 12 14.74 15.38 13.42 20H12C7.58 20 4 23.58 4 28C4 32.42 7.58 36 12 36H19V38H12C6.47543 38 2 33.5246 2 28C2 22.4754 6.47543 18 12 18H12.0056C13.9693 13.3062 18.5794 10 24 10C30.8481 10 36.4523 15.2835 36.9622 22H38C42.4246 22 46 25.5754 46 30C46 34.4246 42.4246 38 38 38Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 42H23V25.83L18.1153 30.7059C17.7257 31.0949 17.0946 31.0946 16.7053 30.7053C16.3158 30.3158 16.3158 29.6842 16.7053 29.2947L24 22L31.295 29.295C31.6848 29.6848 31.6859 30.3164 31.2975 30.7075C30.9072 31.1006 30.2717 31.1017 29.88 30.71L25 25.83V42Z"
  }));
};
export default CloudUploadHifiIcon;